import * as THREE from 'three';

const av = Autodesk.Viewing;

/**
 * @param {RenderModel} model
 * @param {Number[]} fragIds
 * @param {THREE.Plane} [plane]
 * @param {Number} [absTol]
 */
export function cutMesh(model, fragIds, plane, absTol) {
	const cg = av.Extensions.CompGeom;

	const fl = model.getFragmentList();

	if (!plane) {

		let elementBox = new THREE.Box3();
		let bbox = new THREE.Box3();
		elementBox.makeEmpty();

		for (let kk = 0; kk < fragIds.length; kk++) {
			let mesh = fl.getVizmesh(fragIds[kk]);
			if (mesh.geometry && !mesh.geometry.is2d && !mesh.geometry.isLines) {
				fl.getWorldBounds(fragIds[kk], bbox);
				elementBox.union(bbox);
			}
		}

		let distance = -(elementBox.min.z + elementBox.max.z) * 0.5;
		plane = (new THREE.Plane()).setComponents(0, 0, 1, distance);
	}

	const toPlaneCoords = cg.makePlaneBasis(plane);
	let intersects = [];

	for (let ii = 0; ii < fragIds.length; ii++) {
		let fid = fragIds[ii];
		let mesh = fl.getVizmesh(fid);

		if (mesh.geometry && !mesh.geometry.is2d && !mesh.geometry.isLines) {
			cg.xMeshPlane(plane, mesh, intersects);
		}
	}

	let eset = null;
	if (intersects.length) {
		let bbox = new THREE.Box3();
		cg.convertToPlaneCoords(toPlaneCoords, intersects, bbox);

		let tolerance = absTol;
		if (typeof absTol !== "number") {
			tolerance = bbox.getSize(new THREE.Vector3()).length() * 1e-6;
		}

		eset = new cg.EdgeSet(intersects, bbox, tolerance);
		eset.snapEdges();
		eset.sanitizeEdges();
		eset.stitchContours();

		if (eset) {
			return eset.toComplexPolygon();
		}
	}

	return null;
}
